import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { actions } from "frequencyscreen_v_dbinder";
import { NamespacesConsumer, translate } from "react-i18next";
import { withRouter, useLocation } from "react-router-dom";
import { languageOptions, Permissions } from "../../utils";
import { LoggerContext } from "../../contexts";
import IDMPANEL from "idmpanel-pkg";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../config";
import cookie from "react-cookies";
import { Autocomplete } from "@material-ui/lab";
import * as ALL from "../../components";
import { Modal } from "qdm-component-library";
import { Paper, Grid, Typography, Button, TextField } from "@material-ui/core";
import moment from "moment";
import Color from "../../themes/default.json"
import qdmstyles from "./styles.json";
import "./index.css";
import makeStyles from "@material-ui/core/styles/makeStyles";

var aes256 = require("aes256");


const useStyles = makeStyles((theme) => ({
  editschedule:{
    color: theme.palette.text.primary,
  },
  editchildschedule:{
    color: theme.palette.primary.light
  },
  childschedule_background: {
    backgroundColor: theme.palette.background.table
  },
  paper: {
    color:"#6a7888"
  },
  notchedOutline:{
    borderColor:theme.palette.border.textField
  },
  autocomplete: {
    "& .App1-MuiOutlinedInput-notchedOutline":{
      borderColor:theme.palette.border.textField
    },
   },
}));
function EditSchedulelines(props) {
  
  const dispatch = useDispatch();
  const classes = useStyles();
  const location = useLocation();
  const frequencymaster_uom_dropdownData = useSelector(
    (state) =>
      state?.EditNewFrequency_orgfrequencymaster_uom_dropdown_7zRrnReducer
        ?.frequencymaster_uom_dropdown_7zRrn?.data
  );
  const base_frequency_dropdown = useSelector(
    (state) =>
      state?.EditNewFrequency_orgbase_frequency_dropdownReducer
        ?.base_frequency_dropdown?.data
  );
  const scheduleLine_day_dropdown = useSelector(
    (state) => state?.schedule_line_day_dropdownReducer?.schedule_line_day?.data
  );
  const contextType = React.useContext(LoggerContext);
  const [error, setError] = React.useState({});
  const [state, setState] = React.useState({
    permissionData: null,
    edit_schedulelines_bmvfs: null,
    edit_schedulelines_rkgrr: null,
    edit_schedulelines_ffiua: null,
    edit_schedulelines_elomr: null,
    edit_schedulelines_eipqj: null,
    edit_schedulelines_wrgjn: null,
  });

  const changeState = (key, value) => {
    setState({
      ...state,
      [key]: value,
    });
  };
  const valueValidate = () => {
    
    const Day_Based =
      props?.propsState?.editnewfrequency_org_fmmoy &&
      (props.statevalue?.length ?? 1) <
        Math.floor(props?.propsState?.editnewfrequency_org_fmmoy) &&
      props?.propsState?.editnewfrequency_org_jpknc?.display === "Day Based";
    const Detail =
      props?.propsState?.editnewfrequency_org_abdyc &&
      (props.statevalue?.length ?? 1) <
        Math.floor(props?.propsState?.editnewfrequency_org_abdyc) &&
      props?.propsState?.editnewfrequency_org_jpknc?.display === "Detail";
    const Interval =
      props?.propsState?.editnewfrequency_once_every &&
      (props.statevalue?.length ?? 1) <
        Math.floor(props?.propsState?.editnewfrequency_once_every) &&
      props?.propsState?.editnewfrequency_org_jpknc?.display === "Interval";
    const Sequential =
      props?.propsState?.editnewfrequency_org_b4wcn &&
      (props.statevalue?.length ?? 1) <
        Math.floor(props?.propsState?.editnewfrequency_org_b4wcn) &&
      props?.propsState?.editnewfrequency_org_jpknc?.display === "Sequential";
    const User_Defined =
      props?.propsState?.editnewfrequency_org_abdyc &&
      (props.statevalue?.length ?? 1) <
        Math.floor(props?.propsState?.editnewfrequency_org_abdyc) &&
      props?.propsState?.editnewfrequency_org_jpknc?.display === "User Defined";
    return Day_Based || Detail || Interval || Sequential || User_Defined;
  };

  const onclick_bmvfs = (e, index) => {
    
    let validateValue = valueValidate();
    // if (props?.propsState?.editnewfrequency_org_jpknc?.display === "Interval") {
      // setState({ ...state, edit_schedulelines_bmvfs: e?.target?.value });
      // let stateValue = props.statevalue;
      // stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];
      // props.setFun([...stateValue, {}]);
    // }
    if (validateValue) {
      setState({ ...state, edit_schedulelines_bmvfs: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];
      props.setFun([...stateValue, {}]);
    }
  };
  const onchange_rkgrr = (e, index, bigvalues) => {
    let bigvalue = getBigValue();
    if (
      // !e.target.value ||
      // (Number(e.target.value) === bigvalue &&
      //   Number(props?.statevalue[index].schedulelines_ogv4s) === bigvalue) ||
      // (bigvalues <= Number(e?.target?.value) && Number(e?.target?.value) <= 7)
      true
    ) {
      // if (e.target.value <= state.edit_schedulelines_wrgjn) {
      //   setError({ ...error, schedulelines_ogv4s: true });
      // } else {
      //   setError({ ...error, schedulelines_ogv4s: false });
      // }
      setState({
        ...state,
        edit_schedulelines_rkgrr: e?.target?.value,
        edit_schedulelines_rkgr: e?.target?.value,
      });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

      stateValue[index] = {
        ...stateValue[index],
        edit_schedulelines_rkgrr: e?.target?.value,
        edit_schedulelines_rkgr: e?.target?.value,
      };
      props.setFun(stateValue);
    }
  };

  const onchange_ffiua = (v, index) => {
    //
    // if (
    //   props.propsState.editnewfrequency_org_ro3w2 ??
    //   props.propsState.IsBaseFreq
    // ) {
    setState({ ...state, edit_schedulelines_ffiua: v });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      edit_schedulelines_ffiua: v,
    };
    props.setFun(stateValue);
    // }
  };

  const getBaseFrequencyDropdown = (data) => {
    let data1 = base_frequency_dropdown?.result?.filter((item) => {
      return item._id === data || data?._id;
    });
    if (data1?.length) return data1[0];
    return null;
  };

  const onchange_elomr = (e, index) => {
    setState({ ...state, edit_schedulelines_elomr: e?.target?.value });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      edit_schedulelines_elomr: e?.target?.value,
    };
    props.setFun(stateValue);
  };
  const onchange_day = (e, value, index) => {
    
    setState({ ...state, edit_schedulelines_day: value });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      edit_schedulelines_day: value,
    };
    props.setFun(stateValue);
  };
  const onchange_eipqj = (e, index) => {
    setState({
      ...state,
      edit_schedulelines_eipqj: moment(e).format("HH:mm"),
    });
    let stateValue = props.statevalue;
    stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

    stateValue[index] = {
      ...stateValue[index],
      edit_schedulelines_eipqj: moment(e).format("HH:mm"),
    };
    props.setFun(stateValue);
  };
  const getBigValue = () => {
    let fromDay =
      props?.statevalue
        ?.map((val) => Number(val?.edit_schedulelines_wrgjn ?? 0))
        ?.filter((val) => val) ?? [];
    let toDay =
      props?.statevalue
        ?.map((val) => Number(val?.edit_schedulelines_rkgrr ?? 0))
        ?.filter((val) => val) ?? [];
    let arr = [...fromDay, ...toDay];
    arr = arr.sort();
    let len = arr.length;
    return len > 0 ? arr[len - 1] : 0;
  };
  const onchange_wrgjn = (e, index, bigvalues) => {
    let bigvalue = getBigValue();
    if (
      // !e.target.value ||
      // (bigvalue < Number(e?.target?.value) && Number(e?.target?.value) <= 7)
      // bigvalue < Number
      true
    ) {
      //  (
      //   !e.target.value || (bigvalue < Number(e?.target?.value) && !bigvalues) ||
      //   (
      //     +bigvalues >= Number(e?.target?.value) &&
      //     Number(e?.target?.value) <= 7)
      //   // bigvalue <
      // )
      setState({ ...state, edit_schedulelines_wrgjn: e?.target?.value });
      let stateValue = props.statevalue;
      stateValue = stateValue ? JSON.parse(JSON.stringify(stateValue)) : [{}];

      stateValue[index] = {
        ...stateValue[index],
        edit_schedulelines_wrgjn: e?.target?.value,
      };
      props.setFun(stateValue);
    }
  };
  React.useEffect(() => {
    /// initializing transalation
    if (localStorage.defaultLng) {
      const { i18n } = props;
      i18n.changeLanguage(localStorage.defaultLng);
    }
    /// setlogger && dispatch of all events

    /// fetch all permission
  }, []);

  ///fetching all permission

  React.useEffect(() => {}, [state]);

  const Delete = (index) => {
    props.statevalue.splice(index !== 0, 1);
    setState([...props.statevalue]);
  };
  const getData = (data) => {
    let dataList =
      data?.edit_schedulelines_ffiua ??
      (data?.edit_schedulelines_ffiua === undefined ? data?.basefreq : null);
    if (typeof dataList === "string") {
      let option =
        base_frequency_dropdown?.result ||
        base_frequency_dropdown?.result?.map((v) => {
          return {
            ...v,
            val: v?.freqcode + " " + v?.shortdesc,
          };
        }) ||
        [];
      if (option.length > 0) {
        let jsonList = option.filter((val) => val._id === dataList)[0];
        dataList = JSON.parse(JSON.stringify(jsonList));
        dataList.val = dataList.freqcode + " " + dataList.shortdesc;
        dataList.freqcode = dataList.freqcode + " " + dataList.shortdesc;
      }
    }
    return typeof dataList === "string" ? null : dataList;
  };

  const datefilter = () => {
    var arr = [];
    const val = props?.statevalue?.map((p) => {
      if (p.edit_schedulelines_day?.display || p.day?.display) {
        return arr.push(p.edit_schedulelines_day?.display || p.day?.display);
      }
    });
    return (scheduleLine_day_dropdown?.result || []).filter((l) => {
      if (!arr.includes(l.display)) {
        return { l };
      }
    });

    // scheduleLine_day_dropdown?.result
  };

  return (
    <NamespacesConsumer>
      {(t, { i18n }) => (
        <React.Fragment>
          <Paper key={"0"} id={"ZifnB"} elevation={"1"} style={qdmstyles.ZifnB} className={classes.childschedule_background}> 
            <Grid
              key={"0"}
              id={"k8RP1"}
              container={false}
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid
                key={"0"}
                id={"DGwzy"}
                container={false}
                direction={"row"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                aliasName={"user Defined"}
                style={qdmstyles.Yubc}
              >
                <Grid
                  key={"0"}
                  id={"Sqq4d"}
                  container={true}
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  item={true}
                  lg={"12"}
                  style={qdmstyles.HFse}
                >
                  <Grid
                    key={"0"}
                    id={"kWbw8"}
                    container={false}
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Typography
                      key={"0"}
                      id={"WSZqV"}
                      align={"inherit"}
                      color={"initial"}
                      display={"initial"}
                      className={classes.editschedule}
                      variant={"body1"}
                      children={t(
                        "frequency.addNewFrequencySchedule.scheduleLines"
                      )}
                      style={qdmstyles.jEWG}
                    ></Typography>
                  </Grid>
                  <Grid
                    key={"1"}
                    id={"hBm1i"}
                    container={false}
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Button
                      key={"0"}
                      onClick={(e) => onclick_bmvfs(e)}
                      id={"EhOH3"}
                      variant={"text"}
                      color={"primary"}
                      children={"+ Add New"}
                      aliasName={"addnewSch"}
                      disabled={
                        location?.state?.isDisabled === false ? true : false
                      }
                    ></Button>
                  </Grid>
                </Grid>
                <Grid
                  key={"1"}
                  id={"dHOGr"}
                  container={true}
                  direction={"row"}
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                  item={true}
                  lg={"12"}
                  spacing={"2"}
                  md={"12"}
                  sm={"12"}
                  onLoad={(e) => props.setFun(props?.statevalue ?? [{}])}
                >
                  {(props?.statevalue ?? [{}])?.map((data, index) => {
                    return (
                      <React.Fragment key={data?.edit_schedulelines_ffiua ?? index}>
                        <Grid
                          key={"0"}
                          id={"zBJFo"}
                          container={true}
                          direction={"row"}
                          justifyContent={"flex-start"}
                          alignItems={"center"}
                          style={qdmstyles.zBJFo}
                        >
                          {(props?.propsState?.editnewfrequency_org_jpknc
                            ?.display ?? null) === "Day Based" && (
                            <Grid
                              key={"6"}
                              id={"FTOds"}
                              container={false}
                              direction={"row"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              lg={"3"}
                              item={true}
                              md={"4"}
                              sm={"3"}
                              xl={"3"}
                              xs={"3"}
                              style={qdmstyles.nCJAx}
                            >
                              <Typography
                                key={"0"}
                                id={"h9zkG"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                children={"Day"}
                                style={{ fontSize: 12, color: "#6a7888" }}
                              ></Typography>
                              <Autocomplete
                                id={"fW4qT"}
                                style={qdmstyles?.fWqT}
                                value={
                                  data?.edit_schedulelines_day ??
                                  (data?.edit_schedulelines_day === undefined
                                    ? data?.day
                                    : null) ??
                                  null
                                }
                                disabled={
                                  location?.state?.isDisabled === false
                                    ? true
                                    : false
                                }
                                getOptionLabel={(option) => option?.["display"]}
                                options={datefilter()}
                                // getOptionLabel={(option) => option?.["display"]}
                                // options={
                                //   scheduleLine_day_dropdown.result ?? []
                                // }
                                classes={{
                                  paper: classes.paper
                                }}
                                className={classes.autocomplete}
                                onChange={(e, newvalue) =>
                                  onchange_day(e, newvalue, index)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          {(props?.propsState?.editnewfrequency_org_jpknc
                            ?.display ?? null) === "Detail" && (
                            <Grid
                              key={"0"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"2"}
                              md={"2"}
                              sm={"2"}
                              style={{ marginRight: "2%" }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                children={"time"}
                                style={qdmstyles.oPQ}
                              ></Typography>
                              <Grid
                                key={"1"}
                                id={"4BENH"}
                                container={true}
                                direction={"row"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                xl={"12"}
                                lg={"12"}
                              >
                                <DatePicker
                                  id={`DatePicker`}
                                  selected={
                                    data?.edit_schedulelines_eipqj
                                      ? new Date(
                                          moment(
                                            data?.edit_schedulelines_eipqj,
                                            "HH:mm"
                                          )
                                        )
                                      : data?.time
                                      ? new Date(
                                          moment(data?.time, "HH:mm")
                                        )
                                      : ""
                                  }
                                  //  selected={props?.value ? new Date(props?.value) : null}
                                  // onChange={(e) => console.log(e)}
                                  placeholderText="Time"
                                  onChange={(e) => onchange_eipqj(e, index)}
                                  // showTimeSelect
                                  // showTimeSelectOnly
                                  // timeIntervals={30}
                                  // timeCaption="Time"
                                  // dateFormat="H:mm aa"
                                  timeFormat={"HH:mm"}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat={"HH:mm"}
                                  disabled={
                                    location?.state?.isDisabled === false
                                      ? true
                                      : false
                                  }
                                  // key={"0"}
                                  // onChange={(e) => onchange_eipqj(e, index)}
                                  // id={"EiPQj"}
                                  // label={""}
                                  // placeholder={"Time"}
                                  // type="time"
                                  // format={'hh:mm'}
                                  // fullWidth
                                  // value={
                                  //   moment
                                  //     .unix(data?.edit_schedulelines_eipqj)
                                  //     .format("hh:mm") ??
                                  //   moment.unix(data?.time).format("hh:mm")
                                  // }
                                  // variant={"outlined"}
                                  // aliasName={"datettime"}
                                  // margin={"dense"}
                                />
                              </Grid>
                            </Grid>
                          )}{" "}
                          {(props?.propsState?.editnewfrequency_org_jpknc
                            ?.display ?? null) === "User Defined" && (
                            <Grid
                              key={"1"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"1"}
                              md={"1"}
                              sm={"1"}
                              style={{ paddingRight: 15 }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                children={"From Day"}
                                style={qdmstyles.iAQON}
                              ></Typography>
                              <TextField
                                key={"1"}
                                onChange={(e) =>
                                  onchange_wrgjn(
                                    e,
                                    index,
                                    data?.edit_schedulelines_rkgrr
                                      ? data?.edit_schedulelines_rkgrr
                                      : data?.edit_schedulelines_rkgr
                                  )
                                }
                                InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                                value={data?.edit_schedulelines_wrgjn ?? ""}
                                id={"saQ6c"}
                                label={""}
                                placeholder={"From Day"}
                                type={"number"}
                                variant={"outlined"}
                                margin={"dense"}
                                size={"small"}
                                aliasName={"fromDay"}
                                disabled={
                                  location?.state?.isDisabled === false
                                    ? true
                                    : false
                                }
                              ></TextField>
                            </Grid>
                          )}{" "}
                          {(props?.propsState?.editnewfrequency_org_jpknc
                            ?.display ?? null) === "User Defined" && (
                            <Grid
                              key={"2"}
                              id={"kstWr"}
                              container={false}
                              direction={"row"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"1"}
                              md={"1"}
                              sm={"1"}
                              style={{ paddingRight: 15 }}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                children={"To Day"}
                                style={qdmstyles.nRKW}
                              ></Typography>
                              <TextField
                                key={"1"}
                                onChange={(e) =>
                                  onchange_rkgrr(
                                    e,
                                    index,
                                    data.edit_schedulelines_wrgjn
                                  )
                                }
                                value={
                                  data?.edit_schedulelines_rkgrr
                                    ? data?.edit_schedulelines_rkgrr
                                    : data?.edit_schedulelines_rkgr ?? ""
                                }
                                id={"saQ6c"}
                                label={""}
                                InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                                placeholder={"To Day"}
                                type={"number"}
                                variant={"outlined"}
                                margin={"dense"}
                                size={"small"}
                                aliasName={"today"}
                                disabled={
                                  location?.state?.isDisabled === false
                                    ? true
                                    : false
                                }
                              ></TextField>
                            </Grid>
                          )}{" "}
                          {((props?.propsState?.editnewfrequency_org_jpknc
                            ?.display ?? null) === "Day Based" ||
                            (props?.propsState?.editnewfrequency_org_jpknc
                              ?.display ?? null) === "User Defined" ||
                            (props?.propsState?.editnewfrequency_org_jpknc
                              ?.display ?? null) === "Interval" ||
                            (props?.propsState?.editnewfrequency_org_jpknc
                              ?.display ?? null) === "Sequential") && (
                            <Grid
                              key={"3"}
                              id={"kstWr"}
                              container={false}
                              direction={"column"}
                              justifyContent={"flex-start"}
                              alignItems={"flex-start"}
                              item={true}
                              lg={"3"}
                              md={"3"}
                              sm={"3"}
                              style={qdmstyles.gKEir}
                            >
                              <Typography
                                key={"0"}
                                id={"Y8M1c"}
                                align={"inherit"}
                                color={"initial"}
                                display={"initial"}
                                variant={"body1"}
                                children={"Base Frequency"}
                                style={qdmstyles.SBRY}
                              ></Typography>
                              {/* <TextField
                                  key={"1"}
                                  onChange={(e) => onchange_ffiua(e, index)}
                                  value={
                                    data.edit_schedulelines_ffiua ??
                                    data?.basefreq
                                  }
                                  id={"saQ6c"}
                                  label={""}
                                  placeholder={"Base Frequency"}
                                  type={"text"}
                                  variant={"outlined"}
                                  margin={"dense"}
                                  size={"small"}
                                  select={false}
                                  fullWidth={true}
                                  aliasName={"baseFrequency"}
                                  style={qdmstyles.FfIuA}
                                ></TextField> */}

                              <Autocomplete
                                id={"fW4qT"}
                                style={qdmstyles?.fWqT}
                                value={getData(data) ?? {}}
                                // getOptionLabel={(option) =>
                                //   option?.["freqcode"]
                                // }
                                // options={base_frequency_dropdown?.result ?? []}
                                classes={{
                                  paper: classes.paper
                                }}
                                className={classes.autocomplete}
                                getOptionLabel={(option) => option?.freqcode}
                                options={
                                  base_frequency_dropdown?.result?.map((v) => {
                                    return {
                                      ...v,
                                      freqcode:
                                        v?.freqcode + " " + v?.shortdesc,
                                      val: v?.freqcode + " " + v?.shortdesc,
                                    };
                                  }) || []
                                }
                                disabled={
                                  location?.state?.isDisabled === false
                                    ? true
                                    : false
                                }
                                onChange={(e, newvalue) => {
                                  onchange_ffiua(newvalue, index);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                  />
                                )}
                              />
                            </Grid>
                          )}{" "}
                          <Grid
                            key={"4"}
                            id={"kstWr"}
                            container={false}
                            direction={"column"}
                            justifyContent={"flex-start"}
                            alignItems={"flex-start"}
                            item={true}
                            lg={"5"}
                            md={"5"}
                            sm={"5"}
                            style={qdmstyles.YYS}
                          >
                            <Typography
                              key={"0"}
                              id={"Y8M1c"}
                              align={"inherit"}
                              color={"initial"}
                              className={classes.editchildschedule}
                              display={"initial"}
                              variant={"body1"}
                              children={"Remarks"}
                              style={qdmstyles.BoYe}
                            ></Typography>
                            <TextField
                              key={"1"}
                              onChange={(e) => onchange_elomr(e, index)}
                              value={
                                data.edit_schedulelines_elomr ??
                                (props?.totalData?.frequencytype?.display ===
                                props?.propsState?.editnewfrequency_org_jpknc
                                  ?.display
                                  ? data?.remarks
                                  : "")
                              }
                              InputProps={{ classes: {notchedOutline: classes.notchedOutline}}}
                              inputProps={{ maxLength: 100 }}
                              id={"saQ6c"}
                              label={""}
                              placeholder={"Remarks"}
                              type={"text"}
                              variant={"outlined"}
                              margin={"dense"}
                              size={"small"}
                              fullWidth={true}
                              aliasName={"remarks"}
                              disabled={
                                location?.state?.isDisabled === false
                                  ? true
                                  : false
                              }
                            ></TextField>
                          </Grid>
                          {props?.propsState?.editnewfrequency_org_jpknc
                            ?.display && index !== 0 ? (
                            <img
                              width="18px"
                              height="18px"
                              style={{
                                margin: "0px 22px -13px",
                                cursor: "pointer",
                              }}
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAh1BMVEX/////AAD/WVn/oKD/p6f/5ub/9vb/xcX/kZH/Kir/LS3/VVX/vb3/rKz/1dX/RET/TEz/y8v/s7P/ZGT/9fX/Ozv/Njb/t7f/3Nz/m5v/lZX/hIT/7e3/Ghr/aGj/0ND/Pz//b2//eXn/R0f/6Oj/fX3/Gxv/Dg7/c3P/i4v/goL/IyP/ZmaQsKNcAAAFP0lEQVR4nO2da3OiPBiGiyK2VbRuFVEs4mm12/3/v+/18M5OhztqEkMS6H19dELmuQRCznl6qpBou+xP4zgMw/YVwjCedtNFlUFUx3iafwWSvM1S1+Eqs81eZPUutPquQ1ais1PTO5NMXYctz0zD70SxdB25HINCU/DIZ+Q6eglCfb8jm47r+O+yekjwiOdP6rj3qGAQeF3gRG+PCwaBz98NA3fwRNe1x1VyM4JB4GsN57FS9DuFnx+NgTHBINi5lhERDQ0aevkqmntGT7y41kEio4JBELoWAszewiDYe1fYXGkO7nufcXc0GKSdC+mFwYnlqNtv767V09uujUr0hVH+bm/vXzoSV4Qmnt3Ed1GQa8kOmFioOKo2YkUWe0GIc+nLlyLDrMJ41RE9pH8UrhcpvlYWrQ4HDLBQykBUFHtVO319+DUSNEviamLVYoHhtRSz6GIWq0pi1WOE4Sm31Cdev4j4Fu3HqnnM8V+qIlRNniG4N+U8BMWpR+MZ2MUt/y38Bxp61LOI3RcaHWZo6NHnogXBafSXfdTLUKONjq0TGpokuonoKb19hSgTNBzcu8QEnfb6vTccTpLJ6w2wZfF1K7kYyCN4uZE6mSTF8K2Xfz7WZzXWGem0TfKAY/rbdfRyPGvfwcR16LLotkIENUVP+VCuBV+ozS3UHXNMXYetwEHLcOo6bAUSLUPdOSNO0DLMXEetglZTcu06ahW0mpLNN1y5jloFGtLQf7QMjc2OsYGKYTcZntnUpOl0obgEXcgMJtSpsobIVN/E49V1gYb1N5zQkIbe03zDQsJQMKBeIzY0/BGGgnkVNUJm/oBwjllt6DX+HsoYNv8emlxUYB+Z9uE2O7I+rPMjrTMwwrtpOQIa5cX55795/ne1PuyOgeuNs8EYlLPZuzCB0dAiMH8MYUa4oZV8NLQHDXWhoT1oqAsN7UFDXWhoDxrqQkN7VGUIK5KgVTYelMA56OUUA1g/uyinwJHrzd1I9ICtBCBf6GPdl1N0yimCz3KSdjkF9gzej8SaIWwYgIYwdRmWh2GvEg1pSEMa0pCGNKQhDWlIQxrSkIY0pCENaUhDGtKQhjSkIQ1p6Lsh7GUMI6+2DO+P1eoBI6+/HBlGYGho63YYPachDWlIQxrSkIY0pCENaUhDGtKQhjSk4Q83hH3bm2Y4piENafgP2F6DhjSkIQ0fBc7J8cfQ0GpWGtKQhjSkIQ1rZIht/KYZjuF4vcYZftGQhrKGYeMN2zSkIQ1pSEMa0pCGNNQ2XMCe7I0z/Ph5hkszhu/lfGfeGA5oSEMa0pCG3hrOG28IwVky3MKZPjSk4TVD2MYZDD/uG2rsBW3PMCunWPRLwDyXqJyiD1t+d8opoFqNf5M1Q0vQUBswXJvJV5mUhrr8QMOVmXyVwcMnqzLMzeSrjD3DdzP5KoNHpFZlKHPYZxXggdpVGcocK1wFU2uGSWQmY1Via4YBngBjhZ09QzeFqeAcX0N93ivMGfr1LbCAeXtBgGcSaYFFmKCrpnJSgaDMOeNSQAfQkZ6hv08WaB+f0DvfWMBMlHtQ5Icsy+YnZhfa3whjRb5f/H9+57yfs2y9wqLgjCnBp4U4f+dAR4g+uWsXMQZfFD/PWzf6zTq4thFhtKzburYRYPAtPAHdtc55NV05vlJeu8P49ziCPT7dAuvJH0dULXRHJRXjLazncAeM0ZrBnwe1gkf0wnjtWu3Ml6H1zUJEDSnb5OMKBY/ljevbmBja/vkGnZVLP2Mtwpukc9jNyA6rvr1Ovs7oVxy2LRLG/XShFep/9Fi4XhXtpEkAAAAASUVORK5CYII="
                              onClick={(e) => props.Delete(e, index)}
                            />
                          ) : (
                            ""
                          )}
                        </Grid>
                      </React.Fragment>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </React.Fragment>
      )}
    </NamespacesConsumer>
  );
}

export default withRouter(translate()(EditSchedulelines));
